import React, { useEffect, useState, useImperativeHandle, forwardRef, } from "react";

import { Box, Button, Typography } from "@mui/material";
import { CollapseDetail } from "./CollapseDetail/CollapseDetail";
import { ChannelDetailForm } from "./Forms/ChannelDetailForm/ChannelDetail";
import { SourceForm } from "./Forms/SourceForm/SourceForm";
import { TargetForm } from "./Forms/TargetForm/TargetForm";
import { useDispatch, useSelector } from "react-redux";
import { getSingleChannel, updateChannel } from "../../../Store/Features/SingleChannel/SingleChannelSlice";
import "./Detail.css";
import { useParams, useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import { validator } from "../../../Utils/FieldValidator/FieldValidator";


export const Detail = forwardRef((props, ref) => {
  const ChannelData = useSelector(state => state.singleChannelSlice.value);
  const Loading = useSelector(state => state.singleChannelSlice.loading);
  const { slug } = useParams();
  const dispatch = useDispatch();
  const [channelName, setChannelName] = useState({
    value: "", error: ""
  });
  const [srcName, setSrcName] = useState({
    value: "", error: ""
  });
  const [srcApiKeyName, setSrcApiKeyName] = useState({
    value: "", error: ""
  });
  const [srcApiKey, setSrcApiKey] = useState({
    value: "", error: ""
  });
  const [trgName, setTrgName] = useState({
    value: "", error: ""
  });
  const [trgApiKeyName, setTrgApiKeyName] = useState({
    value: "", error: ""
  });
  const [trgApiKey, setTrgApiKey] = useState({
    value: "", error: ""
  });
  const [sourceUrl, setSourceUrl] = useState({
    value: "", error: ""
  });
  const [trgUrl, setTrgUrl] = useState();
  const [user, setUser] = useState(
    {
      value: "", error: ""
    }
  );
  const navigate = useNavigate();


  const save = () => {
    const nameError = validator(channelName.value);
    const SourceApiNameError = validator(srcApiKeyName.value);
    const SourceApiKeyError = validator(srcApiKey.value);

    const SourceNameError = validator(srcName.value);
    const trgNameError = validator(trgName.value);

    const trgApiNameError = validator(trgApiKeyName.value);
    const trgApiKeyError = validator(trgApiKey.value);
    const userError = validator(user.value);

    if (nameError || SourceApiNameError || SourceApiKeyError || SourceNameError || trgNameError || trgApiNameError || trgApiKeyError || userError) {
      setChannelName({ ...channelName, error: nameError });
      setSrcName({ ...srcName, error: SourceNameError });
      setSrcApiKeyName({ ...srcApiKeyName, error: SourceApiNameError });
      setSrcApiKey({ ...srcApiKey, error: SourceApiKeyError });
      setTrgApiKeyName({ ...trgApiKeyName, error: trgApiNameError });
      setTrgApiKey({ ...trgApiKey, error: trgApiKeyError });
      setTrgName({ ...trgName, error: trgNameError });

      setUser({ ...user, error: userError });
    }
    else {
      const data1 = {
        name: channelName?.value,
        source_name: srcName?.value,
        source_api_key_name: srcApiKeyName?.value,
        source_api_key: srcApiKey?.value,
        target_name: trgName?.value,
        target_api_key_name: trgApiKeyName?.value,
        target_api_key: trgApiKey?.value,
        source_url: ChannelData?.source_url,
        target_url: ChannelData?.target_url,
      };
      dispatch(updateChannel(
        { id: slug, data1 }
      )).then(() => {
        dispatch(getSingleChannel(slug));
      });
    }


  };


  useImperativeHandle(ref, () => ({
    save() {
      save();
    },
  }));


  useEffect(() => {
    setChannelName({ ...channelName, value: ChannelData?.name });
    setSrcName({ ...srcName, value: ChannelData?.source_name });
    setSrcApiKeyName({ ...srcApiKeyName, value: ChannelData?.source_api_key_name });
    setSrcApiKey({ ...srcApiKey, value: ChannelData?.source_api_key });
    setTrgName({ ...trgName, value: ChannelData?.target_name });
    setTrgApiKeyName({ ...trgApiKeyName, value: ChannelData?.target_api_key_name });
    setTrgApiKey({ ...trgApiKey, value: ChannelData?.target_api_key });
    setUser({ ...user, value: ChannelData?.created_by?.name });
  }, [ChannelData]);

  // useEffect(() => {
  //   dispatch(getSingleChannel(slug));
  // }, []);


  return (
    <>
      {
        Loading ? (null) : (
          <></>
        )
      }

      <Box className="ContainserDetail">
        <Box sx={{ position: "relative" }}>
          <Box sx={{ display: "flex", width: "10%", alignItems: "center", gap: "12px", position: "absolute", right: 0, top: "-57px" }}>
            <Button className="hover" sx={{ background: "#EC492F", width: "93px", height: "32px" }} onClick={save} >
              <Typography className="button">
                Save
              </Typography>
            </Button>
          </Box>
        </Box>
        <CollapseDetail Title={"Channel Detail"} >
          <ChannelDetailForm channelName={channelName} setChannelName={setChannelName} user={user} />
        </CollapseDetail>
        <CollapseDetail Title={"Source"} >
          <SourceForm srcName={srcName} setSrcName={setSrcName} srcApiKeyName={srcApiKeyName} setSrcApiKeyName={setSrcApiKeyName} srcApiKey={srcApiKey} setSrcApiKey={setSrcApiKey} sourceUrl={sourceUrl} setSourceUrl={setSourceUrl} />
        </CollapseDetail>
        <CollapseDetail Title={"Target"} >
          <TargetForm trgName={trgName} setTrgName={setTrgName} trgApiKeyName={trgApiKeyName} setTrgApiKeyName={setTrgApiKeyName} trgApiKey={trgApiKey} setTrgApiKey={setTrgApiKey} trgUrl={trgUrl} setTrgUrl={setTrgUrl} />
        </CollapseDetail>




      </Box>
    </>
  );
});



